import React from 'react';
import { Card, Flex, Typography, theme } from 'antd';
import { CheckCircleFilled, SyncOutlined } from '@ant-design/icons';

import SearchPerformanceInfoPanel from './SearchPerformanceInfoPanel';

const WHILE_YOU_WAIT_ITEMS = [
  'Syncing usually takes a few hours, sometimes longer',
  'We email you as soon as it is done',
  'Google Search Console data is always at least 48 hours behind',
];

type Props = {
  domains: string[];
  /** Once the first sync has landed, the rows show a ready check instead of spinners. */
  ready?: boolean;
};

function SearchPerformanceDomainSyncCard({ domains, ready = false }: Props) {
  const { token } = theme.useToken();

  return (
    <Card styles={{ body: { padding: token.padding } }}>
      <Flex gap={token.marginLG} align="flex-start">
        <Flex vertical gap={token.marginSM} flex={1}>
          {domains.map((domain) => (
            <Flex
              key={domain}
              align="center"
              gap={token.marginXS}
              style={{
                padding: token.padding,
                border: `1px solid ${token.colorBorderSecondary}`,
                borderRadius: token.borderRadiusLG,
                background: token.colorBgContainer,
              }}
            >
              {ready ? (
                <CheckCircleFilled style={{ fontSize: token.fontSizeLG, color: token.colorSuccess }} />
              ) : (
                <SyncOutlined spin style={{ fontSize: token.fontSizeLG }} />
              )}
              <Typography.Text>{domain}</Typography.Text>
            </Flex>
          ))}
        </Flex>
        <SearchPerformanceInfoPanel title="While you wait" items={WHILE_YOU_WAIT_ITEMS} />
      </Flex>
    </Card>
  );
}

export default SearchPerformanceDomainSyncCard;
